import React from 'react';
import { GraduationCap, Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto container-padding py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-green-600 to-purple-600 flex items-center justify-center">
                <GraduationCap className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="font-bold text-lg text-white">Wellness Coach Academy</h3>
                <p className="text-xs text-gray-400">12-Month Integrated Programme</p>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Transforming wellness enthusiasts into certified industry leaders with our 12-month integrated program.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#program-details" className="hover:text-green-400 transition-colors">
                  Program Details
                </a>
              </li>
              <li>
                <a href="#curriculum" className="hover:text-green-400 transition-colors">
                  Curriculum
                </a>
              </li>
              <li>
                <a href="#testimonials" className="hover:text-green-400 transition-colors">
                  Success Stories
                </a>
              </li>
              <li>
                <a href="#pricing" className="hover:text-green-400 transition-colors">
                  Investment Options
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-green-400 transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Program Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Program Info</h4>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-400">
                Duration: 12 Months
              </li>
              <li className="text-gray-400">
                Seats Available: 60
              </li>
              <li className="text-gray-400">
                Scholarship: 40% Available
              </li>
              <li className="text-gray-400">
                Next Cohort: February 2026
              </li>
              <li className="text-gray-400">
                Certification: International
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <a href="mailto:contact@wellnesscoachacademy.co.uk" className="hover:text-green-400 transition-colors">
                  contact@wellnesscoachacademy.co.uk
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div className="flex flex-col gap-1">
                  <a href="tel:+919050193307" className="hover:text-green-400 transition-colors">
                    +91 90501 93307
                  </a>
                  <a href="tel:+918396938355" className="hover:text-green-400 transition-colors">
                    +91 83969 38355
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">
                  Fit N Shine Wellness Pvt. Ltd.<br/>
                  Office # 105, 1st Floor, Meghna Complex,<br/>
                  Sheela Bypass, Rohtak 124001
                </span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex gap-3 mt-6">
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-gray-800 flex items-center justify-center hover:bg-green-600 transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-gray-800 flex items-center justify-center hover:bg-green-600 transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-gray-800 flex items-center justify-center hover:bg-green-600 transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-gray-800 flex items-center justify-center hover:bg-green-600 transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
          <p>
            &copy; {currentYear} Wellness Coach Academy. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-green-400 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-green-400 transition-colors">
              Terms of Service
            </a>
            <a href="#" className="hover:text-green-400 transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
